module.exports = __webpack_public_path__ + "static/media/ExpandMoreIcon.a8805b8c.svg";